import { IInput, ItemTypes } from '../interfaces';
import { generateProps, generateRules } from './generate';

import { SimpleItem } from 'devextreme-react/form';
import { defaultIInputs } from '../defaults';

const InputDate = (input: IInput) => {
    return (
        <SimpleItem {...generateProps(input, defaultIInputs[ItemTypes.Date])}>
            {generateRules(input, defaultIInputs[ItemTypes.Date])}
        </SimpleItem>
    );
};

export default InputDate;
